import { LogOut, ShieldCheck } from 'lucide-react'
import { Link } from 'react-router'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { NAV_LABELS } from '@/lib/labels'
import { initials } from '@/lib/utils'

interface AccountMenuProps {
  name: string
  roleLabel: string
  onSignOut: () => void
  /** `list` (the mobile drawer) shows the two entries as plain items. */
  variant?: 'menu' | 'list'
  onNavigate?: () => void
}

const ITEM_CLASS =
  'vonk-navitem text-sm'

function UserBlock({ name, roleLabel }: { name: string; roleLabel: string }) {
  return (
    <span className="vonk-sb-user min-w-0">
      <span className="av" aria-hidden>
        {initials(name)}
      </span>
      <span className="flex min-w-0 flex-col text-left">
        <span className="truncate">{name}</span>
        <span className="r truncate">{roleLabel}</span>
      </span>
    </span>
  )
}

/** Avatar and name as one button that opens "Beveiliging (2FA)" and "Uitloggen". */
export function AccountMenu({
  name,
  roleLabel,
  onSignOut,
  variant = 'menu',
  onNavigate,
}: AccountMenuProps) {
  if (variant === 'list') {
    return (
      <div className="flex flex-col gap-0.5">
        <UserBlock name={name} roleLabel={roleLabel} />
        <Link to="/beveiliging" onClick={onNavigate} className={ITEM_CLASS}>
          <ShieldCheck className="size-[18px] shrink-0" aria-hidden />
          {NAV_LABELS.security}
        </Link>
        <button type="button" onClick={onSignOut} className={ITEM_CLASS}>
          <LogOut className="size-[18px] shrink-0" aria-hidden />
          {NAV_LABELS.signOut}
        </button>
      </div>
    )
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-haspopup="menu"
          className="min-w-0 flex-1 rounded-md p-1 text-left transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
        >
          <UserBlock name={name} roleLabel={roleLabel} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start">
        <DropdownMenuItem asChild>
          <Link to="/beveiliging">
            <ShieldCheck className="size-4" aria-hidden />
            {NAV_LABELS.security}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onSignOut}>
          <LogOut className="size-4" aria-hidden />
          {NAV_LABELS.signOut}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
